export const MUIX_LICENSE: string =
	'a5563a2bfbfe6d6f2d1c0a389d421128Tz05MTQxNCxFPTE3NDg0NTI1NDMwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y';

export const LOCATION_API_PATH = 'state.api';
export const ERROR_MESSAGE = {
	// Login
	'Invalid identifier or password': 'Benutzername oder E-Mail Adresse oder Passwort ist falsch.',
	'Your account email is not confirmed': 'Ihr Konto ist noch nicht aktiv.',
	'Your account has been blocked by an administrator': 'Ihr Benutzerkonto wurde gesperrt.',
	// Send E-Mail Confirmation
	'already.confirmed': 'Ihre E-Mail-Adresse wurde schon einmal bestätigt. Sie brauchen nicht nochmal zu bestätigen.',
	'token.invalid': 'Ungültiger Schlüssel.',
	// Forgot-Password
	'This email does not exist': 'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
	'This user is disabled': 'Ihr Benutzerkonto ist deaktiviert.',
	'Incorrect code provided': 'Ungültiger Schlüssel.',
	'Passwords do not match': 'Beide Passwörter stimmen nicht überein.',
	'Incorrect params provided': 'Beide Passwörter stimmen nicht überein.',
	'The provided current password is invalid': 'Ihr altes Password ist falsch.',
	'Your new password must be different than your current password':
		'Ihr neues Passwort muss sich von Ihrem aktuellen Passwort unterscheiden.',
	'User not found': 'Der Benutzername existiert nicht. Bitte überprüfen Sie Ihre Eingabe.',
};

export const APP_STATUS_EDITABLE = ['inBearbeitung', 'inUeberarbeitungDurchAntragssteller'];

export const FILE_UPLOAD_ALLOWED_SIZE = 5000000; // 5MB
export const FILE_UPLOAD_ALLOWED_FORMATS = [
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/pdf',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'image/jpeg',
	'image/bmp',
	'image/png',
];
export const MAX_TEXTBOX_LENGTH = 1500;

export const NOT_FOUND_ERROR_MESSAGE = 'Etwas ist schief gelaufen.';

export const TEMPLATES = {
	Zuwendungsantrag: 4,
};
